import state from './receivedEmails/receivedEmailsState';
import mutations from './receivedEmails/receivedEmailsMutations';
import * as actions from './receivedEmails/receivedEmailsActions';
import * as getters from './receivedEmails/receivedEmailsGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
